import { ButtonType, ButtonWidget, CheckBoxWithLabelWidget, ToastType, ToastWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { hoursLeftToExpire, isCnameVerified } from '../helpers/CustomDomainHelper';
import CustomDomainHttpClient from '../serverAPI/CustomDomainHttpClient';
import { UpdateCustomDomainRequest } from '../serverAPI/requests/AddOrUpdateCustomDomainRequest';
import { AddOrUpdateCustomDomainSettingRequest,CustomDomainSettingResponse,Status } from '../serverAPI/types/CustomDomainTypes';
import { clockIconStyle,customDomainButtonStyle, customDomainContentStyle, customDomainHeaderContainer, customDomainSubHeaderStyle, intermediateDomainTextStyle, intermediateDomainwarningStyle, successIconStyle, unavailableIconStyle } from '../styles/CustomDomainStyles';

export interface ValidateCnameViewState {
    isUploading: boolean;
    checkBox: boolean;
  }

export interface ValidateCnameViewProps {
    customDomainSetting: CustomDomainSettingResponse;
    triggerFetchCustomDomain(): void;
  }

export class ValidateCnameView extends React.PureComponent<ValidateCnameViewProps, ValidateCnameViewState> {
  public constructor(props: ValidateCnameViewProps) {
    super(props);
    this.state = {
      isUploading: false,
      checkBox: false
    };
  }

  private handleChangeWrapper = (): ((checked: boolean) => void) => {
    return (checked: boolean) => {
      this.setState({ checkBox: checked });
    };
  };

  private validateCname = (): void => {
    const customDomainSetting: AddOrUpdateCustomDomainSettingRequest = {
      site_luid: this.props.customDomainSetting.site_luid,
      custom_domain: this.props.customDomainSetting.custom_domain,
      status: Status.requested,
      tls_certificate: '',
      tls_certificate_private_key: ''
    };

    this.setState({isUploading: true});
    CustomDomainHttpClient.requestPutOrPost(new UpdateCustomDomainRequest(customDomainSetting)).then((res: CustomDomainSettingResponse)  => {
      if(res.status === Status.cnameVerificationFailed) {
        ToastWidget.show({
          message: Messages.CustomDomainSetting_validationFailed(),
          testId: 'toast-validate-cname-failed',
          toastType: ToastType.Error,
        });
      }
       this.props.triggerFetchCustomDomain();
     }).catch(err => {
       ToastWidget.show({
        message: Messages.CustomDomainSetting_validateCnameOperationFailed(),
        testId: 'toast-validate-cname-operation-failed',
        toastType: ToastType.Error,
      });
     }).finally(() => {
      this.setState({isUploading: false});
     });
  };

  private renderIcon() {
    if(isCnameVerified(this.props.customDomainSetting?.status)) {
      return <img src={imgPath('notification_success.svg')} alt='' className={successIconStyle}/>;
    }
    if(this.props.customDomainSetting?.intermediate_domain)
      return <img src={imgPath('proceed.svg')} alt='' className={successIconStyle}/>;

    return <img src={imgPath('not_available.svg')} alt='' className={unavailableIconStyle}/>;
  }

  private renderReqestExpirationText() {
    let hoursLeft = hoursLeftToExpire(this.props.customDomainSetting?.request_initiation_date);
    if(hoursLeft <= 0) {
      return <div className={intermediateDomainwarningStyle}>{Messages.CustomDomainSetting_expired()}</div>;
    }
    return <div className={intermediateDomainTextStyle}> {Messages.CustomDomainSetting_expirationDescription({HOURS_LEFT: hoursLeft.toString()})} </div>;
  }

  private renderValidateCnameView() {
    return (
          <>
            <div className={customDomainContentStyle}>
                <CheckBoxWithLabelWidget
                  checked={isCnameVerified(this.props.customDomainSetting?.status) || this.state.checkBox}
                  style={{width: 350}}
                  handleChange={this.handleChangeWrapper()}
                  testId='checkbox-validate-cname'
                  label={Messages.CustomDomainSetting_validateLabelDescription()}
                  disabled={isCnameVerified(this.props.customDomainSetting?.status)} />
              <div className={customDomainButtonStyle}>
                <ButtonWidget buttonType={ButtonType.Primary} onClick={this.validateCname} testId='button-validate-cname-save' disabled={!this.state.checkBox}>
                  {Messages.CustomDomainSetting_validateButton()}
                </ButtonWidget>
              </div>
            </div>
            <div className={customDomainContentStyle}>
              <img src={imgPath('clock_base.svg')} alt='' className={clockIconStyle}/>
              {this.renderReqestExpirationText()}
            </div>
           </>
        );
  }

  public render() {
    return (
    <>
      <div className={customDomainHeaderContainer}>
        {this.renderIcon()}
        <strong className={customDomainSubHeaderStyle}>{Messages.CustomDomainSetting_validateLabel()}</strong>
      </div>
      { this.props.customDomainSetting?.intermediate_domain ? this.renderValidateCnameView() : null }
    </>
    );
  }
}